import { useEffect, useState } from 'react';
import { OfficeBuildingIcon } from '@heroicons/react/outline';
import clsx from 'clsx';
import { LoadingMask } from '../Loading/LoadingMask';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export var OrganizationLogo = function OrganizationLogo(_ref) {
  var src = _ref.src,
      _ref$size = _ref.size,
      size = _ref$size === void 0 ? 'default' : _ref$size,
      _ref$background = _ref.background,
      background = _ref$background === void 0 ? 'default' : _ref$background,
      isLoading = _ref.isLoading;

  var _useState = useState(''),
      imageSrc = _useState[0],
      setImageSrc = _useState[1];
  /**
   * effects
   */


  useEffect(function () {
    setImageSrc(src);
  }, [src]);
  /**
   * methods
   */

  var showLogoAction = function showLogoAction() {
    if (!src.includes('base64')) {
      window.open(src);
    }
  };

  var containerClassname = clsx('relative flex h-[100px] max-h-full w-[100px] max-w-full items-center justify-center overflow-hidden', {
    'rounded ': size === 'small',
    'rounded-xl': size === 'default',
    'bg-black/10': background === 'default' && !src,
    'bg-white/50': background === 'inverted' && !src
  });
  var iconClassname = clsx('text-black/70', {
    'h-5': size === 'small',
    'h-10': size === 'default'
  });
  return /*#__PURE__*/_jsxs("div", {
    className: containerClassname,
    children: [isLoading && /*#__PURE__*/_jsx(LoadingMask, {}), !!imageSrc ? /*#__PURE__*/_jsx("img", {
      src: imageSrc,
      alt: "logo",
      className: clsx('aspect-square h-full w-full object-contain', src !== null && src !== void 0 && src.includes('base64') ? '' : 'cursor-pointer'),
      onClick: showLogoAction
    }, imageSrc) : /*#__PURE__*/_jsx(OfficeBuildingIcon, {
      className: iconClassname
    })]
  });
};